export default __webpack_public_path__ + "static/media/h5-home-banner1.8b0955a1.png";